export const isNavigatorIsChromium = () => {
    return "chrome" in window;
};

export const isNavigatorValidAndWithAnExtension = () => {
    return isNavigatorIsChromium() && "runtime" in window.chrome && "sendMessage" in window.chrome.runtime && "connect" in window.chrome.runtime;
};
